import { css } from "@emotion/core";
import PuffLoader from "react-spinners/PuffLoader";
import './loading.sass'
// Can be a string as well. Need to ensure each key-value pair ends with ;
const override = css`
  display: block;
  margin: 0 auto;
  border-color: green;
`;

function Loading({ open }) {
  return (
    <>
      {open && (
        <div className="loader">
          <div className="sweet-loading">
            <PuffLoader color={"green"} loading={true} css={override} size={80} />
          </div>
        </div>
      )}
    </>
  );
}

export default Loading;
